module.exports = __webpack_public_path__ + "static/media/change-icon.ddebe1a0.svg";